import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { EditIcon } from '../components/shared/Icons';
import TestNTagm from './TestNTagm';


const TABS = [
  {
    id: 'testntag',
    label: 'Compliance',
    
  },
  
];

const COMPLIANCE = [
  { id: 'testtag', label: 'TestNtag', icon: <EditIcon />, component: TestNTagm },
  
];



const FilterSuperTestnTagUpdatePagem = () => {
  const [activeTab, setActiveTab] = useState('testntag');
  const { homeAccent } = useUser();

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'testntag' && <InnerTabsm tabs={COMPLIANCE} defaultId="testtag"/>}
       
      </div>
    </div>
  );
};

export default FilterSuperTestnTagUpdatePagem;